export default "__VITE_ASSET__C3cXKxo4__"